import React from 'react';
import ReusableTable from './ReusableTable';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { Link as MuiLink } from "@mui/material";
import { Link } from 'react-router-dom';
const renderBoxLink = (params: GridRenderCellParams) => {
  return (
    <MuiLink component={Link} to={`/device/${params.value}`} style={{ display: 'block', width: '100%', paddingLeft: '16px', fontSize: '1.2rem' }}>
      {params.value}
    </MuiLink>
  );
};

const columns: GridColDef[] = [
  { field: 'box', headerName: 'Box', flex:1, renderCell: renderBoxLink },
  { field: 'mac_table', headerName: 'MAC Table', flex:1 },
  { field: 'bin', headerName: 'BIN', flex:1 },
  { field: 'data', headerName: 'Data', flex:1 },
  { field: 'table_type', headerName: 'Table Type', flex:1 },
  { field: 'brightness_type', headerName: 'Brightness Type', flex:1 },
  { field: 'scripts_comments', headerName: 'Scripts Comments', flex:1 },
  { field: 'time_stamp', headerName: 'Time Stamp', flex:1 },
];

interface Table5Props {
  search: string;
}

const Table5: React.FC<Table5Props> = ({ search }) => {
  return <ReusableTable fetchUrl="/dacapi_board_current" columns={columns} search={search} />;
};

export default Table5;
